<template>
  <div style="width: 100%;">
  <el-col  :span="auto">
    <el-menu
      class="menu"
      :collapse="isCollapse"
      background-color="#304156"
      text-color="#ffffff"
      active-text-color="#3C87D6"
      :default-active="curActive"
      :collapse-transition="false"
      unique-opened
      @select="handleSelectMenu"
    >

      <div v-show="display_flag==0" v-for="(item,index) in menu_01" :key="index">
        <el-menu-item :index="item.i" >
          <i :class="item.icon"></i>
          <span slot="title" style="font-size:20px;">{{item.text}}</span>
        </el-menu-item>
      </div>
      <div v-show="display_flag==1"  v-for="(item,index) in menu_jiudian" :key="index">
        <el-menu-item :index="item.i" >
          <i :class="item.icon"></i>
          <span slot="title" style="font-size:20px;">{{item.text}}</span>
        </el-menu-item>
      </div>
      <div v-show="display_flag==2"  v-for="(item,index) in menu_peisong" :key="index">
        <el-menu-item :index="item.i" >
          <i :class="item.icon"></i>
          <span slot="title" style="font-size:20px;">{{item.text}}</span>
        </el-menu-item>
      </div>   
    </el-menu>
  </el-col>
</div>
</template>

<script>
import eventBus from "@/api/eventBus.js"
import global from "@/global/global.js";
export default {
  data() {
    return {
      isCollapse: false, // 是否折叠
      display_flag:1,
      menu_01: [  //普通管理员
        {
          i: "/shouye",
          text: "首页",
          icon: "iconfont icon-fabu",
          role: ["super", "normal"],
        },
        {
          i: "/shangpin_fabu",
          text: "商品发布",
          icon: "iconfont icon-fabu",
          role: ["super", "normal"],
        },
        {
          i: "/shangpin_guanli",
          text: "商品管理",
          icon: "iconfont icon-guanli",
          role: ["super", "normal"],
        },
        {
          i: "/dingdan_shangpin",
          text: "订单查看",
          icon: "iconfont icon-dingdan",
          role: ["super", "normal"],
        },
        {
          i: "/qijiandian",
          text: "旗舰店申请",
          icon: "iconfont icon-dingdan",
          role: ["super", "normal"],
        },
        {
          i: "/nianshen",
          text: "年审",
          icon: "iconfont icon-dingdan",
          role: ["super", "normal"],
        },
        {
          i: "/shuomingshu",
          text: "使用手册",
          icon: "iconfont icon-zhiwei",
          role: ["super", "normal"],
        }
      ],
      menu_jiudian: [  //普通管理员
        {
          i: "/shouye",
          text: "首页",
          icon: "iconfont icon-fabu",
          role: ["super", "normal"],
        },
        {
          i: "/fabu_jiudian",
          text: "房间发布",
          icon: "iconfont icon-fabu",
          role: ["super", "normal"],
        },
        {
          i: "/shangpin_guanli",
          text: "房间管理",
          icon: "iconfont icon-guanli",
          role: ["super", "normal"],
        },
        {
          i: "/dingdan",
          text: "订单查看",
          icon: "iconfont icon-dingdan",
          role: ["super", "normal"],
        },
        {
          i: "/nianshen",
          text: "年审",
          icon: "iconfont icon-dingdan",
          role: ["super", "normal"],
        },
        {
          i: "/shuomingshu",
          text: "使用手册",
          icon: "iconfont icon-zhiwei",
          role: ["super", "normal"],
        }
      ],
      menu_peisong: [  //普通管理员
        {
          i: "/shouye",
          text: "首页",
          icon: "iconfont icon-fabu",
          role: ["super", "normal"],
        },
        {
          i: "/shangpin_fabu",
          text: "商品发布",
          icon: "iconfont icon-fabu",
          role: ["super", "normal"],
        },
        {
          i: "/shangpin_guanli",
          text: "商品管理",
          icon: "iconfont icon-guanli",
          role: ["super", "normal"],
        },
        {
          i: "/dingdan_peisong",
          text: "订单查看",
          icon: "iconfont icon-dingdan",
          role: ["super", "normal"],
        },
        {
          i: "/nianshen",
          text: "年审",
          icon: "iconfont icon-dingdan",
          role: ["super", "normal"],
        },
        {
          i: "/shuomingshu",
          text: "使用手册",
          icon: "iconfont icon-zhiwei",
          role: ["super", "normal"],
        }
      ],
      menu_01_ctr:0,
      menu_02_ctr: 0,
      menu_03_ctr:0,
    };
  },
  created() {
    var flag = 0;
    if (global.hangye == "购物") {
      flag = 0;
    } else if (global.hangye == "酒店") {
      flag = 1;
    } else if (global.hangye == "配送") {
      flag = 2;
    } else {
      flag = 0;
    }
    this.display_flag = flag;
    this.menu_01_ctr = 1;
    this.menu_02_ctr = 0;
    this.menu_03_ctr = 0;
  },
  
  //计算属性
  computed: {
    curActive() {
      return this.$route.path;
    },
  },
  methods: {
    handleSelectMenu(item) {
      eventBus.$emit("ENTER_HOUTAI_RIGHT",item);
    },

  },
};
</script>

<style lang="scss" scoped>

.text-center {
  text-align: center; /* 设置文字水平居中 */
  text-align: justify; /* 使文字两端对齐，适用于中文等长度不确定的语言 */
  text-justify: inter-word; /* 设置词间距调整方式，使得中文也能形成合适的对齐效果 */
}
.menu:not(.el-menu--collapse) {
  width: 100%;
  height: 100%;
}
.menu {
  border-right: 0px;

  .logo-container {
    display: flex;
    height: 50px;
    align-items: center;
    justify-content: left;
    .logo {
      border-radius: 40%;
      margin-left: 10%;
      height: 50px;
    }
  }

  .iconfont {
    margin-right: 10px;
  }

  .el-submenu.is-active {
    i {
      color: #3c87d6;
    }
    span {
      color: #3c87d6;
    }
  }

  .el-menu {
    .el-menu-item {
      background-color: #202f3f !important;

      &:hover {
        background-color: rgba(0, 0, 0, 0.5) !important;
      }
    }
  }
}
</style>